// extracted by mini-css-extract-plugin
export var avatarContainer = "_h2-0";
export var avatarTypingWave = "_h2-i";
export var gray = "_h2-f";
export var green = "_h2-c";
export var icon = "_h2-9";
export var image = "_h2-1";
export var lg = "_h2-6";
export var md = "_h2-5";
export var presenceDot = "_h2-b";
export var red = "_h2-d";
export var sm = "_h2-4";
export var status = "_h2-a";
export var typingDot = "_h2-h";
export var typingPill = "_h2-g";
export var xl = "_h2-7";
export var xs = "_h2-3";
export var xxl = "_h2-8";
export var xxs = "_h2-2";
export var yellow = "_h2-e";